import { useState } from "react";
import { updateRenewAmount } from "../../services/account/api";
import { useAuth } from "../../contexts/auth";

export function useCredits() {
  const { partner, RefreshUser } = useAuth();
  const [selectedAmount, setSelectedAmount] = useState(
    parseInt(partner.renew_amount) || 100);

  const [renewCreditSwitch, setRenewCreditSwitch] = useState(
    !!parseInt(partner.renew_amount));

  const updateSelectedAmount = (value) => {
    setSelectedAmount(value);
    if (renewCreditSwitch) {
      updateRenewAmount({ renew_amount: `${value}00` })
      .then(() => {
        RefreshUser();
      });
    }
  };

  return {
    renewCreditSwitch,
    setRenewCreditSwitch,
    selectedAmount,
    updateSelectedAmount,
  };
}
